let revalidator = require('revalidator');
let _ = require('lodash');

module.exports = {
    /**
     * Заполнение поля по указанному пути
     * Используется для Input'ов
     * @param {Object} args
     * @param {Object} state
     */
    inputText ({ path, value }, state) {
        if (!path) {
            return;
        }

        let setPath = path.split('.');
        state.set(setPath, value);
    },

    /**
     * Обрезаем текст по завершении ввода
     * @param {Object} args
     * @param {String} args.value
     * @param {String} args.path
     * @param {Object} state
     */
    trimText ({ path, value }, state) {
        if (!path) {
            return;
        }

        let setPath = path.split('.');

        state.set(setPath, _.trim(value));
    },

    /**
     * Валидация текста для Input'а с обязательным значением
     * @param {Object} args
     * @param {Object} state
     */
    validateText ({ scheme, errorPath, errorMessage, validationValue, value }, state) {
        let target = { value: validationValue || value };
        let message = errorMessage;

        if (!errorPath || !scheme) {
            return;
        }

        let type = _.get(scheme, 'properties.value.type');

        if (type === 'number') {
            target.value = Number(target.value);
        }
        if (type === 'string') {
            target.value = _.trim(target.value);
        }

        let status = revalidator.validate(target, scheme);

        let { errors, valid } = status;
        let errorPathArray = errorPath.split('.');

        // если всё хорошо, то запустим ещё и функцию-валидатор
        if (valid) {
            let validatorFunction = _.get(scheme, 'properties.value.validator.func');
            if (validatorFunction && !validatorFunction(target.value)) {
                valid = false;
                message = _.get(scheme, 'properties.value.validator.message');
            }
        }

        if (valid) {
            if (state.get(errorPathArray)) {
                state.unset(errorPathArray);
            }
        } else {
            message = message || _.chain(errors).first().get('message').value();
            state.set(errorPathArray, message);
        }
    },

    /**
     * Валидация текста для Input'а только для снятия ошибочного состояния
     * @param {Object} args
     * @param {Object} state
     */
    validateUnsetError ({ scheme, errorPath, validationValue, value }, state) {
        let target = { value: validationValue || value };

        if (!errorPath || !scheme) {
            return;
        }

        let type = _.get(scheme, 'properties.value.type');

        if (type === 'number') {
            target.value = Number(target.value);
        }
        if (type === 'string') {
            target.value = _.trim(target.value);
        }

        let status = revalidator.validate(target, scheme);
        let { valid } = status;

        let errorPathArr = errorPath.split('.');

        if (valid && state.get(errorPathArr)) {
            state.unset(errorPathArr);
        }
    }
};



// WEBPACK FOOTER //
// ./actions/form.js